<ion-header>
  <ion-toolbar color="medium">
    <ion-title>Ship To Overrides</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="cancel()">Cancel</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <p *ngIf="loading" class="ion-text-center">
    <ion-spinner></ion-spinner>
  </p>
  <div *ngIf="!loading && values">
    <div class="alert ion-padding">
      <strong>CAUTION:</strong> Use these fields in certain circumstances only. A typical use is
      preparing an item from Inventory HOLD to ship for a customer. Setting them does not move the
      pallet on its own &mdash; use the Ready to Ship control on the pallet screen to change its
      state.
    </div>
    <form #form="ngForm" (ngSubmit)="submit(form)">
      <ion-item button detail="true" (click)="pickCustomer()">
        <ion-label position="stacked">Customer</ion-label>
        <ion-input readonly placeholder="Tap to choose..." [value]="customerName"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="stacked">PO</ion-label>
        <ion-input name="itempo" type="text" placeholder="..." [(ngModel)]="values.itempo">
        </ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="stacked">Caliper</ion-label>
        <ion-select name="caliper2" interface="popover" [(ngModel)]="values.caliper2">
          <ion-select-option *ngFor="let item of calipers" [value]="item.tid" class="ion-text-wrap">
            {{item.name}}
          </ion-select-option>
        </ion-select>
      </ion-item>
      <ion-item button detail="true" (click)="pickSize()">
        <ion-label position="stacked">Size</ion-label>
        <ion-input readonly placeholder="Tap to choose..." [value]="sizeName"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="stacked">Part No.</ion-label>
        <ion-input name="part_no_" type="text" placeholder="..." [(ngModel)]="values.part_no_">
        </ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="stacked">Product Spec</ion-label>
        <ion-textarea name="additional_information" rows="4" placeholder="..."
          [(ngModel)]="values.additional_information"></ion-textarea>
      </ion-item>
      <div class="ion-padding-top ion-text-center">
        <ion-button size="large" type="submit" [disabled]="saving" expand="block">
          {{saving ? 'Saving...' : 'Update'}}
        </ion-button>
      </div>
    </form>
  </div>
</ion-content>
